import React from "react";
import { Check, Minus, Crown } from "lucide-react";

const ROWS = [
  ["Create users & send invites", true, true],
  ["Unlock locked accounts", true, true],
  ["Delete agents & reviewers", true, true],
  ["Approve / reject results, manage elections & hierarchy", true, true],
  ["Download backups & restore setup data", true, true],
  ["Full restore (results, incidents, assignments)", false, true],
  ["Rotate any user's password", false, true],
  ["Delete admin accounts", false, true],
  ["Assign polling units to agents", false, true],
  ["Switch a user between Agent and Reviewer", false, true],
  ["Election-day freeze / thaw / schedule", false, true],
  ["Reset system for a fresh election", false, true],
  ["Wipe the audit log", false, true],
  ["Transfer ownership", false, true],
];

const Mark = ({ ok }) => ok
  ? <Check size={14} className="text-emerald-400 inline"/>
  : <Minus size={14} className="text-zinc-600 inline"/>;

export const PermissionsOverview = ({ ownerEmail }) => (
  <div className="border border-white/10 mt-10" data-testid="permissions-overview">
    <div className="px-4 py-3 border-b border-white/10 flex items-center justify-between flex-wrap gap-2">
      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">Who can do what</div>
        <div className="text-sm mt-1">Admins vs. the system owner</div>
      </div>
      {ownerEmail && <div className="text-xs text-zinc-400 flex items-center gap-2" data-testid="permissions-owner-email"><Crown size={13} className="text-emerald-400"/>Owner: <span className="text-white">{ownerEmail}</span></div>}
    </div>
    <div className="grid grid-cols-12 px-4 py-2 text-[10px] uppercase tracking-[0.3em] text-zinc-500 border-b border-white/5">
      <div className="col-span-8">Action</div>
      <div className="col-span-2 text-center">Admin</div>
      <div className="col-span-2 text-center">Owner</div>
    </div>
    <div className="divide-y divide-white/5">
      {ROWS.map(([label, admin, owner]) => (
        <div key={label} className="grid grid-cols-12 px-4 py-2 items-center text-xs" data-testid="permissions-row">
          <div className="col-span-8 text-zinc-300">{label}</div>
          <div className="col-span-2 text-center"><Mark ok={admin}/></div>
          <div className="col-span-2 text-center"><Mark ok={owner}/></div>
        </div>
      ))}
    </div>
    <div className="px-4 py-2 text-[11px] text-zinc-500">Need an owner-only action? Ask the owner listed above.</div>
  </div>
);
